import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=08cda300&scoped=true&"
import script from "./GaugeChart.vue?vue&type=script&lang=ts&"
export * from "./GaugeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cda300",
  null
  
)

export default component.exports